module.exports = __webpack_public_path__ + "img/25_54.fcd26645.png";